import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postDepartments({ body }) {
  return BaseService.post(REST.DEPARTMENTS, body);
}

function putDepartments({ body, id }) {
  return BaseService.put(REST.DEPARTMENTS_ID(id), body);
}

function getDepartments(params) {
  return BaseService.get(REST.DEPARTMENTS, {
    params: paramsFilter({ params }),
  });
}

function deleteDepartments({ id }) {
  return BaseService.delete(REST.DEPARTMENTS_ID(id));
}

export default {
  postDepartments,
  putDepartments,
  getDepartments,
  deleteDepartments,
};
